/** @flow */

import {
  GetServiceSectionStatusesSuccess,
  GetServiceSectionStatusesError,
} from "@modules/shared/constants/actions";
import * as serviceSectionStatusesReducer from "./reducers";
import initialState from "./state";
import type { ServiceSectionStatusesState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: ServiceSectionStatusesState = initialState, action: Object): Object => {
  const act = {
    [GetServiceSectionStatusesSuccess]:
      serviceSectionStatusesReducer.onGetServiceSectionStatusesSuccess,
    [GetServiceSectionStatusesError]:
      serviceSectionStatusesReducer.onGetServiceSectionStatusesError,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
